const ID_TOKEN_KEY = "_token";

export const getToken = () => {
  const token = window.localStorage.getItem(ID_TOKEN_KEY);
  if (token && token !== "Edutalk" && token !== "null" && token !== "undefined") {
    return token;
  }
  try {
    const userStr = window.localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const userToken =
        user?.token ||
        user?.auth_tokennoibo ||
        user?.access_token ||
        user?.data?.token ||
        user?.data?.auth_tokennoibo;
      if (userToken && userToken !== "Edutalk") {
        saveToken(userToken);
        return userToken;
      }
    }
  } catch (e) {}
  return token;
};

export const saveToken = token => {
  if (token) {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
  }
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken, ID_TOKEN_KEY };